import { IComment, ICommentContent } from "interfaces/comment";
import { useWriteComment } from "hooks/comments/useWriteComment";

interface Result {
  createProjectComment: (content: ICommentContent) => Promise<IComment>;
  updateProjectComment: (
    commentId: number,
    content: ICommentContent
  ) => Promise<IComment>;
  deleteProjectComment: (commentId: number) => Promise<void>;
}

export function useWriteProjectComment(
  projectId: number,
  onCommentsChanged: () => void
): Result {
  const { createComment, updateComment, deleteComment } = useWriteComment(
    `projects/${projectId}`,
    onCommentsChanged
  );

  return {
    createProjectComment: createComment,
    updateProjectComment: updateComment,
    deleteProjectComment: deleteComment
  };
}
